import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiSettings, FiMoreVertical } from "react-icons/fi";
import styles from "./StaffTable.module.css";
import { API_URL } from '../../config/api';

const StaffFormer = () => {
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    const fetchStaff = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("❌ Нет токена! Авторизация не выполнена.");
        const saved = localStorage.getItem("staffDeleted");
        if (saved) setStaff(JSON.parse(saved));
        return;
      }

      try {
        const response = await axios.get(
          `${API_URL}/api/users?status=deleted`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.status === 200 && Array.isArray(response.data.data)) {
          const staffData = response.data.data.map((user) => ({
            id: user.id,
            name: `${user.name} ${user.surname}`,
            position: user.role,
            phone: user.phone,
          }));

          setStaff(staffData);
          localStorage.setItem("staffDeleted", JSON.stringify(staffData));
        } else {
          console.warn("⚠️ API вернул неожиданный формат данных:", response.data);
          const saved = localStorage.getItem("staffDeleted");
          if (saved) setStaff(JSON.parse(saved));
        }
      } catch (error) {
        console.error("Ошибка при получении данных уволенных сотрудников:", error);
        const saved = localStorage.getItem("staffDeleted");
        if (saved) {
          setStaff(JSON.parse(saved));
          console.warn("⚠️ Данные уволенных сотрудников восстановлены из localStorage.");
        }
      }
    };

    fetchStaff();
  }, []);

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Имя</th>
            <th>Должность</th>
            <th>Телефон</th>
            <th><FiSettings size={18} /></th>
          </tr>
        </thead>
        <tbody>
          {staff.map((person) => (
            <tr key={person.id}>
              <td>{person.name}</td>
              <td>{person.position}</td>
              <td>{person.phone}</td>
              <td className={styles.iconCell}>
                <FiMoreVertical size={20} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StaffFormer;
